<template>
    <div class="giving giving-report p-5">
        <h3 class="uppercase text-white font-bold text-20 mb-4">
            {{ $t("Your Giving") }}
        </h3>
        <ul class="giving__list">
            <li class="giving__list-item">
                <div class="giving-title">{{ $t("This Month") }}</div>
                <div class="giving-summa">
                    $ {{ $getState("monthDonation") }}
                </div>
            </li>
            <li class="giving__date">
                <p class="text-12 tracking-normal text-white opacity-60">
                    {{ srtReplace() }}
                </p>
            </li>
            <li class="giving__list-item">
                <div class="giving-title">{{ $t("Last Roundup") }}</div>
                <div class="giving-summa">
                    $ {{ $getState("lastRoundUps") }}
                </div>
            </li>
            <li class="giving__list-item">
                <div class="giving-title">{{ $t("Last Transaction") }}</div>
                <div class="giving-summa">
                    $ {{ $getState("lastTransaction") }}
                </div>
            </li>
        </ul>
        <Button
            type="link"
            classes="w-full your-giving-btn mb-5"
            :text="$t('View details')"
            route="/giving"
        ></Button>
    </div>
</template>

<script>
import Button from "../UI/Button";
export default {
    name: "Giving",
    components: { Button },

    data: function() {
        return {
            hasCards: false
        };
    },

    mounted() {
        this.getStatistic();
    },

    methods: {
        srtReplace: function() {
            if (this.$user("is_pause_donation")) {
                return this.$t("Donations paused");
            }

            if (!this.hasCards) {
                return this.$t(
                    "You have $0 in scheduled donations every month"
                );
            } else {
                let str = this.$t("Your donation on {date} will be ${summa}");
                return str
                    .replace("{date}", this.$currentDate)
                    .replace("{summa}", this.$getState("monthDonation"));
            }
        },
        getStatistic: function() {
            this.$http.post("user/donationsstat").then(res => {
                if (res && res.status !== undefined && res.status) {
                    this.hasCards =
                        res.data.hasCards !== undefined
                            ? res.data.hasCards
                            : false;

                    this.$setState(
                        "monthDonation",
                        parseFloat(res.data.total).toFixed(2)
                    );
                    this.$setState(
                        "lastTransaction",
                        parseFloat(res.data.last_transaction).toFixed(2)
                    );
                    this.$setState(
                        "lastRoundUps",
                        parseFloat(res.data.last_roundups).toFixed(2)
                    );
                }
            });
        }
    }
};
</script>
